import iframeTab from "./iframe";
import imageTab from "./image";
import healthTab from "./health";
import rolesTab from "./roles";
import { keyBy } from "lodash";

const tabTypes = keyBy([iframeTab, imageTab, healthTab, rolesTab], "id");

export default tabTypes;
